import resume from '../assets/pdf/resume.pdf'
import image from '../assets/jpeg/cody.jpeg'
export const headerData = {
    name: 'Cody Tran',
    title: "Tech Enthusiast",
    description:"Hello 👋. I'm Cody - a curious developer based in US",
    image: image,
    resumePdf: resume
}
